import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, UsersIcon, TagIcon } from 'lucide-react';
export function TripSpotlight() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const facts = [{
    icon: CalendarIcon,
    label: 'Datum',
    value: '23. – 28. April 2026'
  }, {
    icon: ClockIcon,
    label: 'Dauer',
    value: '5 Tage / 4 Nächte'
  }, {
    icon: UsersIcon,
    label: 'Teilnehmer',
    value: 'Bis zu 18 Kreative'
  }, {
    icon: TagIcon,
    label: 'Preis',
    value: 'ab 350 € p.P.'
  }];
  const images = ['https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-3.jpg', 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-7.jpg', 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-12.jpg'];
  return <section id="aktuelle-reise" className="py-24 md:py-32 px-6 relative z-20 bg-white" data-id="element-340">
      <div className="max-w-7xl mx-auto" data-id="element-341">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-342">
          {/* Left Content */}
          <div className="lg:col-span-5" data-id="element-343">
            <motion.span variants={itemVariants} className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-344">
              Aktuelle Reise
            </motion.span>
            <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-heading text-[#1a1a2e] mb-8" data-id="element-345">
              Burgau, <span className="italic text-[#8a8a9a]" data-id="element-346">Portugal</span>
            </motion.h2>

            <motion.p variants={itemVariants} className="text-[#4a4a5a] text-lg font-light leading-relaxed mb-10" data-id="element-347">
              Erlebe Shootings an der dramatischen Algarve-Küste, an goldenen
              Stränden und versteckten Buchten. Unsere exklusive Cliff Villa
              bietet Meerblick, Privatpool und Platz für bis zu 18 Gäste — die
              perfekte Kulisse für unvergesslichen Content. Inklusive ca. 50 €
              Verpflegungspauschale.
            </motion.p>

            <div className="grid grid-cols-2 gap-4" data-id="element-348">
              {facts.map((fact, index) => <motion.div key={index} variants={itemVariants} className="bg-[#f5f5f7] border border-[#e2e2e6] p-5 rounded-xl shadow-sm" data-id="element-349">
                  <fact.icon className="w-5 h-5 text-brand-accent mb-3" data-id="element-350" />
                  <div className="text-xs text-[#8a8a9a] uppercase tracking-wider mb-1" data-id="element-351">
                    {fact.label}
                  </div>
                  <div className="text-[#1a1a2e] font-medium" data-id="element-352">{fact.value}</div>
                </motion.div>)}
            </div>
          </div>

          {/* Right Gallery Grid */}
          <div className="lg:col-span-7 grid grid-cols-2 gap-4 h-[600px]" data-id="element-353">
            <motion.div variants={itemVariants} className="col-span-1 h-full" data-id="element-354">
              <img src={images[0]} alt="Portugal scenery" className="w-full h-full object-cover rounded-xl shadow-sm" data-id="element-355" />
            </motion.div>
            <div className="col-span-1 grid grid-rows-2 gap-4 h-full" data-id="element-356">
              <motion.div variants={itemVariants} className="row-span-1" data-id="element-357">
                <img src={images[1]} alt="Portugal coastal" className="w-full h-full object-cover rounded-xl shadow-sm" data-id="element-358" />
              </motion.div>
              <motion.div variants={itemVariants} className="row-span-1" data-id="element-359">
                <img src={images[2]} alt="Portugal architecture" className="w-full h-full object-cover rounded-xl shadow-sm" data-id="element-360" />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}